<template>
  <div>
    <main-layout>
      <v-container>
        <div class="text-xs-center" style="padding-top: 2em">
          <h3 class="headline" style="display: inline">{{ $t('Redeem Code') }}</h3>
          <p>
            {{
              $t(
                'For filling the redeem code/ support code when purchasing premium package from official resellers'
              )
            }}
          </p>
        </div>
        <template v-if="loading">
          <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
        </template>
        <template v-else-if="supportDetail">
          <p>{{ $t('If you have any question, contact your supporter here') }}</p>
          <div class="z-border-red pa-2 mb-3">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img :src="supportDetail.photo" @error="onError" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="supportDetail.fullname"></v-list-tile-title>
                <v-list-tile-sub-title v-html="supportDetail.contact"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </div>
        </template>
        <div class="form-control text-xs-center">
          <redeem-code></redeem-code>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import RedeemCode from '@/components/elements/RedeemCode'

export default {
  data() {
    return {
      RedeemCodecode: null,
      supportDetail: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    VueRecaptcha,
    ScaleLoader,
    RedeemCode
  },
  directives: {
    uppercase: {
      update(el) {
        el.value = el.value.toUpperCase()
      }
    }
  },
  mounted: function () {
    var vm = this
    vm.$store.dispatch('updateBotDetail').then(
      function () {
        if (vm.selectedBot.supportusers) {
          vm.loading = true
          vm.getSupportUser().then(
            function () {
              vm.loading = false
            },
            function () {
              vm.loading = false
            }
          )
        } else {
          vm.loading = false
        }
      },
      function () {
        vm.loading = false
      }
    )
  },
  methods: {
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    getSupportUser: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          supportusers: vm.selectedBot.supportusers
        }
        api.getSupportUser(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.supportDetail = response.data
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/redeem/redeemcode.vue